import React from 'react'
import LocalShipping from '@mui/icons-material/LocalShipping';
import InMarketHierarchyHierarchyList from './HierarchyList';
import InMarketHierarchyFlatList from './FlatList';
import FlatEdit from './FlatEdit';
import InMarketHierarchyList from './HierarchyList';
import HierarchyEdit from './HierarchyEdit';
import Create from './Create'

//true
const isHierarchy = true; // expects true or false injected by plop

const listComponent = isHierarchy
  ? InMarketHierarchyHierarchyList
  : InMarketHierarchyFlatList;


const editComponent = isHierarchy
  ? HierarchyEdit
  : FlatEdit;

const conf = {
    name: 'kelloggs_in_market_hierarchy',
    icon: <LocalShipping />,
    list: listComponent,
    edit: editComponent,
    create: Create,
    options: {
        label: "In Market Hierarchy",
        items: true
    }
};

export default conf;